
import React, { useEffect, useRef, useState } from "react";
import { RxHamburgerMenu } from "react-icons/rx";
import { IoCloseOutline } from "react-icons/io5";
import { RiSearchLine } from "react-icons/ri";
import { LiaBoxSolid } from "react-icons/lia";
import { CgClose } from "react-icons/cg";

import { FiHeart } from "react-icons/fi";
import { PiShoppingCartLight } from "react-icons/pi";
import { HiOutlineUserCircle } from "react-icons/hi2";
import { Link } from "react-router-dom";

const Header = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [fixMenu, setFixMenu] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenResSearchBox, setResSearchBox] = useState(false);


  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const closeDropdown = () => {
    setIsOpen(false);
  };

  const stickyMenuHandler = () => {
    const scrollH = window.scrollY;
    if (scrollH > 500) {
      setFixMenu(true);
    } else {
      setFixMenu(false);
    }
  };




  return (
    <>
      {/* <nav className="bg-nav_bg border-b border-bc py-3">
        <div className="container">
          <div className="flex justify-center gap-1 sm:gap-3">
            <button type="button" className="sm:px-4 px-3 py-1.5 sm:py-2 text-primary_dark bg-white font-medium rounded-sm leading-[1.3] hover:bg-primary hover:text-white focus:bg-primary focus:text-white active:bg-white active:text-white transition-all duration-300">Products</button>
            <button type="button" className="sm:px-4 px-3 py-1.5 sm:py-2 text-bc font-medium rounded-sm leading-[1.3] hover:bg-primary hover:text-white focus:bg-primary focus:text-white active:bg-white active:text-white transition-all duration-300">Merchants</button>
            <button type="button" className="sm:px-4 px-3 py-1.5 sm:py-2 text-bc font-medium rounded-sm leading-[1.3] hover:bg-primary hover:text-white focus:bg-primary focus:text-white active:bg-white active:text-white transition-all duration-300">Restaurant</button>
          </div>
        </div>
      </nav> */}

      <nav
        className={`py-3 md:py-4 bg-nav_bg z-50 ${fixMenu ? "sticky top-0 left-0 w-full nav__sticky" : ""
          }`}
        style={{ boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.15)" }}
      >
        <div className="container">
          <div className="flex justify-between items-center">
            <div className="inline-flex items-center">
              {/* <button
                onClick={() => setShowMenu(true)}
                className="w-8 h-8 flex items-center text-black md:hidden mr-4"
              >
                <RxHamburgerMenu className="text-2xl text-black" />
              </button> */}
              <Link href={"/"} className="inline-block">
                <img
                  src={`/images/logo.png`}
                  width={150}
                  alt="Ocelot"
                /> 
              </Link>
            </div>

            <div className="flex 2xl:w-[calc(100%-300px)] lg:w-[calc(100%-200px)]">
              <form className={`col lg:relative lg:pr-14 fixed top-0 left-0 w-full z-[100] sm:px-8 py-12 p-4 lg:p-0 bg-[#EEEEEE] lg:bg-transparent main__seach__box ${isOpenResSearchBox ? 'open__menu' : null}`}>
                <button onClick={() => setResSearchBox(!isOpenResSearchBox)} type="button" className="w-12 h-12 inline-flex items-center justify-center text-2xl bg-white rounded-full shadow absolute -bottom-6 left-1/2 -translate-x-1/2 lg:hidden"><CgClose /></button>
                <div className="relative">
                  <input type="text" className="w-full h-12 bg-white text-base pl-5 pr-12 font-semibold border-0 rounded-sm" required />
                  <button type="submit" className="w-[38px] h-[38px] inline-flex items-center justify-center rounded-sm bg-primary text-white absolute top-1/2 -translate-y-1/2 right-1 z-10">
                    <RiSearchLine className="text-lg" />
                  </button>
                </div>
              </form>

              <div className="inline-flex items-center gap-3 sm:gap-4 xl:gap-x-8">
                <button type="button" onClick={() => setResSearchBox(!isOpenResSearchBox)} className="p-2 text-white lg:hidden">
                  <RiSearchLine className="text-xl" />
                </button>

                <Link href={"#"} className="inline-block text-white text-center">
                  <FiHeart className="text-xl mx-auto" /><span className="hidden md:block text-center">Wishlist</span>
                </Link>
                <Link href={"#"} className="inline-block text-white text-center">
                  <PiShoppingCartLight className="text-2xl mx-auto" /><span className="hidden md:block text-center">Cart</span>
                </Link>
                <Link href={"#"} className="inline-block text-white text-center">
                  <LiaBoxSolid className="text-2xl mx-auto" /><span className="hidden md:block text-center">Orders</span>
                </Link>
                <Link href={"#"} className="inline-block text-white text-center">
                  <HiOutlineUserCircle className="text-2xl mx-auto" /><span className="hidden md:block text-center">Login/Sign Up</span>
                </Link>
              </div>
            </div> 
          </div>
        </div>
      </nav>



    </>
  );
};

export default Header;